import { gql } from "apollo-boost";

export const CREATE_FABRIC = gql`
mutation CreateFabric($data: FabricInput!) {
  createFabric(data: $data) {
    id
    name
    price
    pricePerRoll
    originPricePerRoll
    image
    imageString
    shop {
      id
    }
    isDeleted
    createdAt
    updatedAt
    note
  }
}
`

export const DELETE_FABRIC = gql`
mutation DeleteFabric($where: FabricWhereInputOne!) {
  deleteFabric(where: $where) {
    id
  }
}
`

export const UPDATE_FABRIC = gql`
mutation UpdateFabric($data: FabricInput!, $where: FabricWhereInputOne!) {
  updateFabric(data: $data, where: $where) {
    id
    name
    price
    pricePerRoll
    originPricePerRoll
    image
    imageString
    shop {
      id
    }
    isDeleted
    createdAt
    updatedAt
    note
    amountRoll
    qtyPerRoll
  }
}
`
